import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/resources/StockLevelsReport.jsx.
const COLUMNS: ReportColumn[] = [
  { key: 'name', label: 'Item' },
  { key: 'category', label: 'Category' },
  { key: 'unit', label: 'Unit' },
  { key: 'facility', label: 'Facility' },
  { key: 'current_quantity', label: 'Current Qty', align: 'right' },
  { key: 'reorder_point', label: 'Reorder Point', align: 'right' },
  { key: 'low_stock', label: 'Low Stock' },
];

export function StockLevelsReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Inventory Stock Levels"
      description="Current stock levels per item, flagging what is below reorder point."
      endpoint="/reports/resources/stock-levels"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'inventory_category')}
    />
  );
}
